import { Head, Link } from '@inertiajs/react'
import type { SalesminerOrganizationUpload as Upload } from '@/types/serializers'
import UploadListItem from './_components/UploadListItem'
import EmptyState from './_components/EmptyState'
import HeaderActions from './_components/HeaderActions'

interface Props {
    uploads: Upload[]
}

export default function Index({uploads}: Props) {
    return (
        <>
            <Head title="Organization Uploads - Super Admin"/>

            <div className="min-h-screen bg-gray-50">
                <div className="bg-white shadow">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex justify-between items-center py-6">
                            <div className="flex items-center space-x-4">
                                <Link href="/admin" className="text-indigo-600 hover:text-indigo-700">
                                    ← Back to Dashboard
                                </Link>
                                <h1 className="text-2xl font-bold text-gray-900">
                                    Organization Uploads
                                </h1>
                            </div>

                            <HeaderActions />
                        </div>
                    </div>
                </div>

                <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <div className="px-4 py-6 sm:px-0">
                        {uploads.length === 0 ? (
                            <EmptyState />
                        ) : (
                            <div className="bg-white shadow overflow-hidden sm:rounded-md">
                                <ul className="divide-y divide-gray-200">
                                    {uploads.map((upload) => (
                                        <UploadListItem key={upload.id} upload={upload} />
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}